import ProductoForm from './ProductoForm'
export {ProductoForm}
export default ProductoForm
